import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform, useReducedMotion } from "framer-motion";

export const PhoneFrame = ({ children, className = "", tilt = false, style = {}, testId = "phone-frame" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [7, -7]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-9, 9]), { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    if (!tilt || reduce || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => { mx.set(0); my.set(0); };

  return (
    <motion.div
      ref={ref}
      data-testid={testId}
      aria-hidden="true"
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`phone-frame ${className}`}
      style={{ ...style, rotateX: tilt && !reduce ? rx : 0, rotateY: tilt && !reduce ? ry : 0, transformStyle: "preserve-3d" }}
    >
      <div className="phone-screen w-full h-full">
        {children}
      </div>
    </motion.div>
  );
};
